export class AttachmentUploadDeniedError extends Error {
    constructor(message: string = 'Attachment upload denied by server') {
        super(message);
        this.name = 'AttachmentUploadDeniedError';
    }
}
